import * as o from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/FacebookLogo.es.js";
const e = o.forwardRef((a, c) => /* @__PURE__ */ o.createElement(r, { ref: c, ...a, weights: t }));
e.displayName = "FacebookLogoIcon";
const n = e;
export {
  n as FacebookLogo,
  e as FacebookLogoIcon
};
